<template>
  <data-loader>
    <adaptive-flashcard v-if="loaded" />
    <p
      v-else-if="error"
      class="load-error"
    >
      {{ error }}
    </p>
  </data-loader>
</template>

<script>
import DataLoader from '@/components/sims/DataLoader.vue';
import AdaptiveFlashcard from '@/components/sims/adaptive/AdaptiveFlashcard.vue';

export default {
  components: {
    AdaptiveFlashcard,
    DataLoader,
  },
  data() {
    return {
      loaded: false,
      error: null,
    };
  },
  computed: {
    sessionId() {
      return this.$route.params.sessionId;
    },
  },
  // Reloads the attempt so a refresh shows the same question, or the result if it has ended
  mounted() {
    return this.$store.dispatch('adaptiveSim/fetchSession', this.sessionId).then(({ catSession }) => {
      if (catSession.status !== 'in_progress') {
        return this.$router.replace({ name: 'adaptiveSim#result', params: this.$route.params });
      }
      this.loaded = true;
    }).catch(error => {
      console.error(error);
      this.error = 'The simulation could not be loaded. Please refresh the page.';
    });
  },
};
</script>

<style lang="scss" scoped>
.load-error {
  text-align: center;
  margin-top: 2rem;
}
</style>
